import React from 'react';
import { AlignLeft, Calendar } from 'lucide-react';
import { WORK_ORDER_LABELS, workOrderSectionTestId } from '../../workOrderSections';
import { CreatedLine, DetailLabel } from './DetailsList';
import './shared.css';

export interface WorkOrderTopProps {
    /** Section 1: a `WorkOrderHeader` with `showBadges={false}` (the pills sit in the title bar) */
    header: React.ReactNode;
    /** Section 2: a `BuildingCard` */
    building: React.ReactNode;
    description?: string;
    /** Renders the Ändra / Lägg till link after the Beskrivning heading */
    onEditDescription?: () => void;
    /** Shown in place of the description while it is being edited */
    descriptionEditor?: React.ReactNode;
    /** Storage format (YYYY-MM-DD hh:mm:ss) */
    createdAt: string;
    createdByName?: string;
}

/**
 * Sections 1–3 of a work order, the same on the admin modal and the guest
 * page, one per row in the spec order: the title as the heading of the
 * page, the building card, then a card with the description and Skapad.
 */
export const WorkOrderTop: React.FC<WorkOrderTopProps> = ({
    header,
    building,
    description,
    onEditDescription,
    descriptionEditor,
    createdAt,
    createdByName
}) => (
    <div className="wo-top">
        <div className="wo-top__title">{header}</div>
        <div className="wo-top__building">{building}</div>
        <div className="wo-top__description wo-card" data-testid={workOrderSectionTestId('description')}>
            <DetailLabel
                icon={AlignLeft}
                label={WORK_ORDER_LABELS.sectionDescription}
                onEdit={descriptionEditor ? undefined : onEditDescription}
                empty={!description?.trim()}
                heading
            />
            {descriptionEditor ?? (
                description?.trim()
                    ? <p className="wo-top__description-text mb-0">{description}</p>
                    : <p className="mb-0 text-muted">{WORK_ORDER_LABELS.noDescription}</p>
            )}

            <div className="wo-top__created">
                <DetailLabel icon={Calendar} label={WORK_ORDER_LABELS.created} />
                <CreatedLine createdAt={createdAt} createdByName={createdByName} />
            </div>
        </div>
    </div>
);

export default WorkOrderTop;
